import { postWithJson } from 'library/utils/serviceUtil'

/**
 * 获取应用列表
 */
export const appList = (params = {}) => {
	return postWithJson('/app/list.np', params)
}
/**
 *
 * @param params
 */
export const addApp = (params = {}) => {
	return postWithJson('/app/addOrMod.np', params)
}
/**
 * 应用下架
 */
export const releaseApp = (params = {}) => {
	return postWithJson('/app/release.np', params)
}

/**
 * 获取应用分类
 */
export const getTypeList = (params = {}) => {
	return postWithJson('/app/type/list.np', params)
}

/**
 * 新增应用分类
 * @param { string } name 应用分类名称
 */
export const addAppType = (params = {}) => {
	return postWithJson('/app/type/add.np', params)
}

/**
 * 获取开通审核列表
 */
export const reviewList = (params = {}) => {
	return postWithJson('/app/review/list.np', params)
}

/**
 * 获取审核信息
 */
export const reviewInfo = (params = {}) => {
	return postWithJson('/app/review/info.np', params)
}

/**
 * 审核信息
 */
export const review = (params = {}) => {
	return postWithJson('/business/app/review.np', params)
}

/**
 * 绑定应用
 */
export const bindApp = (params = {}) => {
	return postWithJson('/business/app/binding.np', params)
}

/**
 * 功能包列表
 */
export const pkgList = (params = {}) => {
	return postWithJson('/app/pkgList.np', params)
}
/**
 * 朱雀线路
 */
export const getCallLine = (params = {}) => postWithJson('/call/lineList.np', params)
